import { InsuranceType, MainPath } from "Constants/constants";

import { CaravanCoverage } from "Store/interfaces/products/coverage";

export const PATH = `/${MainPath.CHECK_PRICE}/${InsuranceType.CARAVAN}`;

export const DEFAULT_SELECTED_COVERAGES = [
  CaravanCoverage.CARAVAN_FULL_OWN_DAMAGE,
  CaravanCoverage.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE,
  CaravanCoverage.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_1,
  CaravanCoverage.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_2,
  CaravanCoverage.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_3,
  CaravanCoverage.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_1,
  CaravanCoverage.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_2,
  CaravanCoverage.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_3,
];

export const DEFAULT_DEDUCTIBLE_CARAVAN = "8000";

export enum Movables {
  NONE = "0",
  FOURTYFIVE_THOUSAND = "1",
  SIXTYFIVE_THOUSAND = "2",
  HUNDRED_AND_FIFTEEN_THOUSAND = "3",
}

export enum CaravanInsuranceType {
  CARAVAN_FULL_OWN_DAMAGE = "caravanKasko",
  CARAVAN_FIRE_AND_THEFT = "caravanFireAndTheft",
  CARAVAN_SUPER = "caravanSuper",
}
